import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DOCS_NAV_ORDER } from "../lib/docsNav";
import styles from "./PageNav.module.css";

function ChevronLeft() {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        d="M10 3.5 5.5 8l4.5 4.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronRight() {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        d="M6 3.5 10.5 8 6 12.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function PageNav() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const normalized = pathname === "/docs/kira-arts" ? "/docs/kira-arts/getting-started" : pathname;
  const index = DOCS_NAV_ORDER.findIndex((entry) => entry.path === normalized);

  if (index === -1) return null;

  const prev = index > 0 ? DOCS_NAV_ORDER[index - 1] : undefined;
  const next = index < DOCS_NAV_ORDER.length - 1 ? DOCS_NAV_ORDER[index + 1] : undefined;

  if (!prev && !next) return null;

  return (
    <nav className={styles.pageNav} aria-label={t("pageNav.ariaLabel")}>
      {prev ? (
        <Link to={prev.path} className={`${styles.card} ${styles.prev}`}>
          <span className={styles.title}>
            <ChevronLeft />
            {t(prev.labelKey)}
          </span>
          <span className={styles.caption}>{t("pageNav.previous")}</span>
        </Link>
      ) : (
        <span className={styles.spacer} />
      )}
      {next ? (
        <Link to={next.path} className={`${styles.card} ${styles.next}`}>
          <span className={styles.title}>
            {t(next.labelKey)}
            <ChevronRight />
          </span>
          <span className={styles.caption}>{t("pageNav.next")}</span>
        </Link>
      ) : (
        <span className={styles.spacer} />
      )}
    </nav>
  );
}
